import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { computed, provide, readonly, ref } from 'vue';
import { MenuItemFn } from './menu-item';
import MenuSection from './MenuSection.vue';
import { Editor } from '@tiptap/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'Menu',
  props: {
    commandSets: {},
    editor: {}
  },
  setup(__props: any) {

const props = __props;

/**
 * When this value is set to anything other than null,
 * these command sets will populate the menu.
 */
const commandOverrides = ref<MenuItemFn[] | null>(null);

/**
 * Calling this changes the menu contents.
 * Useful for creating "sub-menus" within the same toolbar.
 * @param com The menu item function array.
 */
function overrideCommands(com: MenuItemFn[]) {
  commandOverrides.value = com;
}

/**
 * Revert the menu to its initial state, which
 * is using the props given to the MenuSection.
 */
function revertCommandOverrides() {
  commandOverrides.value = null;
}

const commandSource = computed(() => commandOverrides.value ?? props.commandSets);

provide('menuCommandOverride', {
  commandOverrides: readonly(commandOverrides),
  overrideCommands,
  revertCommandOverrides,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commandSource.value, (commandSet, index) => {
      return (_openBlock(), _createBlock(MenuSection, {
        key: index,
        editor: _ctx.editor,
        commands: commandSet
      }, null, 8, ["editor", "commands"]))
    }), 128))
  ]))
}
}

})